module.exports = __webpack_public_path__ + "img/computer-age-1.505c44a6.png";